window.checkTreeviews = function (route) {
	$(".agrofleet-treeview-selector").each(async function () {
		const $container = $(this);
		if ($container.html() !== "") return;
		const TREEVIEW_STORAGE_KEY = "1.0.0@treeview";
		const pageId = $container.attr("pageId");
		const type = $container.attr("type");
		const level = $container.attr("level");
		let url = "/treeview/getGroupsVehicles";
		if (type === "users") url = "/treeview/getGroupsUsers";
		if (type === "operators") url = "/treeview/getRegionalsOperators";
		const isVehiclesDataType = url === "/treeview/getGroupsVehicles";
		const cachedTreeview = isVehiclesDataType && getCachedVehiclesTreeview(level, route);
		if (isVehiclesDataType && cachedTreeview) {
			let { level: data, routeSettings: treeViewPredefinition } = cachedTreeview;
			if (!treeViewPredefinition) treeViewPredefinition = await fetchPredefinitionsSettings(route);
			renderTreeview({ data, treeViewPredefinition }, pageId);
			cacheVehiclesTreeview(level, route, { data, treeViewPredefinition });
			return;
		}
		const treeviewData = await fetchData(url, route, $container);
		if (isVehiclesDataType) cacheVehiclesTreeview(level, route, treeviewData);
		renderTreeview(treeviewData, pageId);
		return;

		function getCachedVehiclesTreeview(level, route) {
			const cachedTreeview = JSON.parse(sessionStorage.getItem(TREEVIEW_STORAGE_KEY)) ?? { level: {}, routeSettings: {} };
			const cachedLevel = cachedTreeview.level[level];
			const cachedRouteSettings = cachedTreeview.routeSettings[route];
			if (!cachedLevel) return;
			return { level: cachedLevel, routeSettings: cachedRouteSettings };
		}

		function cacheVehiclesTreeview(level, route, { data, treeViewPredefinition }) {
			const cachedTreeview = JSON.parse(sessionStorage.getItem(TREEVIEW_STORAGE_KEY)) ?? { level: {}, routeSettings: {} };
			if (data) cachedTreeview.level[level] = data;
			if (treeViewPredefinition) cachedTreeview.routeSettings[route] = treeViewPredefinition;
			sessionStorage.setItem(TREEVIEW_STORAGE_KEY, JSON.stringify(cachedTreeview));
		}

		async function fetchData(url, route, $container) {
			return new Promise((resolve) => {
				window.gpssat.App._ajax(
					"GET",
					url,
					{
						level: $container.attr("level"),
						value: $container.attr("value"),
						single: $container.attr("single"),
						clientWhere: $container.attr("clientWhere"),
						profileWhere: $container.attr("profileWhere"),
						regionalWhere: $container.attr("regionalWhere"),
						operationWhere: $container.attr("operationWhere"),
						vehicleType: $container.attr("vehicleType"),
						vehicleTypeNot: $container.attr("vehicleTypeNot"),
						route,
					},
					(data) => resolve(data),
				);
			});
		}

		async function fetchPredefinitionsSettings(route) {
			return new Promise((resolve) => {
				window.gpssat.App._ajax(
					"GET",
					"/users/getTreeViewPredefinitions",
					{
						route,
					},
					(data) => resolve(data),
				);
			});
		}

		function renderTreeview({ data, treeViewPredefinition }, pageId) {
			createJSTree2(data, pageId);
			const $treeview = $(`#treeview2-${pageId}`);
			$treeview.bind("ready.jstree", () => applyPredefinedFilter($treeview, { data, treeViewPredefinition }, pageId));
		}
	});
};

window.applyPredefinedFilter = function (tree, data, pageId) {
	if (!data.treeViewPredefinition) return;
	let settings = JSON.parse(data.treeViewPredefinition.filters);
	let searchValues = settings.searchValues;
	let fieldsValues = settings.fieldsValues;
	let searchRoute = data.treeViewPredefinition.search_route;
	let autoLoadData = settings.autoLoadData;
	let hourToDecimal = settings.hourToDecimal;
	let predefinedFilter = settings.predefinedFilter;

	if (predefinedFilter !== null) {
		const date_range = $("#date_range-" + pageId).data("daterangepicker");
		if (date_range.ranges[predefinedFilter]) {
			let start_date = date_range.ranges[predefinedFilter][0];
			let end_date = date_range.ranges[predefinedFilter][1];
			date_range.setStartDate(start_date);
			date_range.setEndDate(end_date);
		}
	}

	searchValues.forEach(function (item) {
		tree.jstree().check_node(item);
		tree.jstree()._open_to(item);
	});

	fieldsValues.forEach(function (item) {
		$(`#custom-fields-search2-${pageId} [name='${item.field_name}']`).val(item.value).change();
	});

	$("#save_settings" + pageId).attr("checked", true);
	$("#decimal_time" + pageId).attr("checked", hourToDecimal);

	if (autoLoadData) {
		sendSearch2(pageId, searchRoute, true);
	}
};

window.createJSTree2 = function (jsondata, pageId) {
	$("#treeview2-" + pageId).jstree({
		core: {
			data: jsondata,
		},
		checkbox: {
			three_state: false,
			cascade: "down",
		},
		plugins: ["search", "checkbox", "types", "wholerow", "ui", "sort"],
		search: {
			case_sensitive: false,
			show_only_matches: true,
		},
		types: {
			group: {
				icon: "icon-IconBListFolder-24",
			},
			vehicle: {
				icon: "icon-IconBListMachine-24",
			},
			client: {
				icon: "icon-IconBListFactory-24",
			},
			operation: {
				icon: "icon-IconBListCompany-24",
			},
			profile: {
				icon: "fa fa-users fa-lg",
			},
			user: {
				icon: "fa fa-user fa-lg",
			},
			regional: {
				icon: "icon-IconBListFolder-24",
			},
			operator: {
				icon: "fa fa-user fa-lg",
			},
		},
	});
	$("#treeview2-field" + pageId).keyup(function () {
		if (typeof to !== "undefined") {
			clearTimeout(to);
		}
		to = setTimeout(function () {
			var v = $("#treeview2-field" + pageId).val();
			$("#treeview2-" + pageId)
				.jstree(true)
				.search(v);
		}, 250);
	});
};
